"use client";

import clsx from "clsx";
import { type ComponentProps, useMemo } from "react";

import { mod } from "@shared/utils";

import s from "./trail-number.module.scss";

export type TrailNumberProps = ComponentProps<"div"> & {
  className?: string;
  children: React.ReactNode;
  variant?: "very hard" | "hard" | "medium" | "easy";
  size?: "24" | "64";
};

export const TrailNumber = (props: TrailNumberProps) => {
  const { className, children, variant, size } = props;

  const updatedVariant = useMemo(() => {
    return variant?.split(" ").join("-");
  }, [variant]);

  const mods = mod(s, {
    variant: updatedVariant,
    size,
  });

  return <div className={clsx(s.root, className, mods)}>{children}</div>;
};

TrailNumber.displayName = "TrailNumber";
